import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../../components/MainBody/MainBody";
import MainTabList from "../../../components/MainBody/MainTabList";
import ProgramSummary from "./ProgramSummary/ProgramSummary";
import Policies from "./Policies/Policies";
import RiskAssessment from "./RiskAssessment/RiskAssement";

const tabsKey = [
  {
    name: "Risk Assessment",
    tabName: "risk-assessment",
    value: 1,
  },
  {
    name: "Policies",
    tabName: "policies",
    value: 2,
  },
  {
    name: "AML/CTF Program",
    tabName: "program-summaries",
    value: 3,
  },
];

const Program = ({ permission }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("childTab") || "risk-assessment";

  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab,
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);

  useEffect(() => {
    navigate(
      `?tab=program&childTab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      },
    );
  }, [activeTab, navigate]);

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        innerBody={true}
        actionAlign={"end"}
        actionContent={""}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={"border-none"}
        >
          {activeTab === 1 ? (
            <RiskAssessment
              readAccess={permission?.["risk-assessments"]?.read}
              writeAccess={permission?.["risk-assessments"]?.write}
            />
          ) : activeTab === 2 ? (
            <Policies
              readAccess={permission?.["policies"]?.read}
              writeAccess={permission?.["policies"]?.write}
            />
          ) : activeTab === 3 ? (
            <ProgramSummary
              readAccess={permission?.["program-summaries"]?.read}
              writeAccess={permission?.["program-summaries"]?.write}
            />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default Program;
